// Stripe Configuration
export const STRIPE_PUBLISHABLE_KEY = 'pk_live_51RmFoOB1IunPVFKvxxMeuuS8YDxYhsgu6BSGMHLW3qW6ldk8koLvQoOJ6wkQNBfZlRDvRHzOhZm9cA2RZD5CYfzU00BNqh3Vfu';

// Get Stripe key - use the hardcoded key directly
export const getStripeKey = () => {
  return STRIPE_PUBLISHABLE_KEY;
}; 